import { createApiSlice } from "@common";
import {
  CURD_CONTACT_ROLE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addContactRole",
    method: "post",
    url: CURD_CONTACT_ROLE,
    stateKey: "message",
  },
  {
    name: "getContactRole",
    method: "get",
    url: CURD_CONTACT_ROLE,
    stateKey: "data",
  },
  {
    name: "updateContactRole",
    method: "put",
    url: CURD_CONTACT_ROLE,
    stateKey: "message",
  },
  {
    name: "deleteContactRole",
    method: "delete",
    url: CURD_CONTACT_ROLE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "contactRole",
  apiConfig,
  customReducers,
);
const contactRoleSlice = slice;
// Export the slice's reducer
export default contactRoleSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addContactRole,
  getContactRole,
  updateContactRole,
  deleteContactRole
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
